module.exports = __webpack_public_path__ + "static/media/l.13b209af.jpg";